import { IoArrowUp, IoArrowDown } from "react-icons/io5";
import { FaRegHandPointer } from "react-icons/fa";

export const BoxCard = ({
  icon,
  growth,
  alt,
  title,
  total,
  lobData = [],
  color,
  darkcolor,
  animate = true,
  onClick,
  handPosition = "top-2 right-2", // ✅ configurable
}) => {
  const growthNum = parseFloat(
    typeof growth === "string" ? growth.replace("%", "") : growth,
  );

  const isPositive = !isNaN(growthNum) && growthNum > 0;
  const isNegative = !isNaN(growthNum) && growthNum < 0;

  const isClickable = typeof onClick === "function";

  return (
    <div
      onClick={isClickable ? onClick : undefined}
      className={`${color} rounded-[10px] flex p-2 pr-3 relative w-full h-full shadow-lg mb-3 md:mb-0 
        ${isClickable ? "cursor-pointer" : "cursor-default"}`}
    >
      {/* 🔴 Hand pointer (ONLY if onClick present) */}
      {isClickable && (
        <div
          className={`flex justify-center items-center absolute ${handPosition}`}
        >
          <button className="relative p-1 text-white bg-[#e03f3f] rounded-full focus:outline-none group">
            <span className="text-xs text-white">
              <FaRegHandPointer />
            </span>
            <span className="absolute inset-0 rounded-full bg-sky-400 opacity-75 blur-md animate-ping"></span>
          </button>
        </div>
      )}

      <div className="w-1/3 flex items-center justify-center">
        <img src={icon} alt={alt} className="w-[53px] h-[47px]" />
      </div>

      <section className="text-sm font-medium w-full">
        <div className="flex justify-between font-bold items-center gap-[2px]">
          <p>{title}</p>

          <div className="flex gap-[2px]">
            {growth !== undefined && growth !== null && growth !== "" && (
              <span
                className={`flex items-center gap-1 text-[13px] ${
                  isPositive
                    ? "text-green-600"
                    : isNegative
                      ? "text-red-600"
                      : ""
                }`}
              >
                {growth}
                {isPositive && <IoArrowUp />}
                {isNegative && <IoArrowDown />}
              </span>
            )}

            {total !== undefined && total !== null && total !== "" && (
              <div
                className={`${darkcolor} py-0.5 px-1 rounded-md shadow-lg ${
                  animate ? "animate-pulse" : ""
                }`}
              >
                {total}
              </div>
            )}
          </div>
        </div>

        {Array.isArray(lobData) &&
          lobData.map(({ lob, number }, index) =>
            lob && number !== undefined && number !== null ? (
              <div key={index} className="flex justify-between font-medium">
                <p>{lob}</p>
                <p>{number}</p>
              </div>
            ) : null,
          )}
      </section>
    </div>
  );
};
